var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('button',{staticStyle:{"width":"100%","height":"100%","border":"none"},style:({background:_vm.option.attribute.bgColor,color:_vm.option.attribute.textColor,
            borderRadius:_vm.option.attribute.radius+'px'}),on:{"click":function($event){return _vm.redirect()}}},[_vm._v(" "+_vm._s(_vm.cptData.value)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }